import { isApiError } from '@portals-platform/api-client';
import { useTranslation } from '@portals-platform/i18n';
import { Button, EmptyState } from '@portals-platform/ui';
import { ArrowLeftIcon, FileXIcon } from 'lucide-react';

function errorKind(error: Error | null | undefined): 'accessDenied' | 'notFound' | 'generic' {
  if (isApiError(error) && error.status === 403) return 'accessDenied';
  if (isApiError(error) && error.status === 404) return 'notFound';
  return 'generic';
}

interface CertificateLoadErrorProps {
  error: Error | null | undefined;
  onBack: () => void;
}

export function CertificateLoadError({ error, onBack }: CertificateLoadErrorProps) {
  const { t } = useTranslation();
  const kind = errorKind(error);

  return (
    <EmptyState
      icon={<FileXIcon />}
      title={t(`certificates.details.loadError.${kind}.title`)}
      description={t(`certificates.details.loadError.${kind}.description`)}
      action={
        <Button variant="outline" onClick={onBack}>
          <ArrowLeftIcon aria-hidden="true" />
          {t('certificates.details.backToCertificates')}
        </Button>
      }
    />
  );
}
